import { render, staticRenderFns } from "./SocietyIncorporationDetails.vue?vue&type=template&id=34fb7610&scoped=true&"
import script from "./SocietyIncorporationDetails.vue?vue&type=script&lang=js&"
export * from "./SocietyIncorporationDetails.vue?vue&type=script&lang=js&"
import style0 from "./SocietyIncorporationDetails.vue?vue&type=style&index=0&id=34fb7610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb7610",
  null
  
)

export default component.exports